import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMedalLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.41968 2C10.1374 2 10.8001 2.38457 11.1562 3.00772L12 4.48447L12.8439 3.00772C13.2 2.38457 13.8626 2 14.5804 2H19.1384C20.2902 2 21.0122 3.24422 20.4408 4.24421L17.0592 10.1621C18.2615 11.4191 19 13.1233 19 15C19 18.866 15.866 22 12 22C8.13401 22 5 18.866 5 15C5 13.1233 5.73855 11.419 6.94087 10.1621L3.55923 4.24421C2.98781 3.24422 3.70986 2 4.86159 2H9.41968ZM12 10C9.23858 10 7 12.2386 7 15C7 17.7614 9.23858 20 12 20C14.7614 20 17 17.7614 17 15C17 12.2386 14.7614 10 12 10ZM12 13C13.1046 13 14 13.8954 14 15C14 16.1046 13.1046 17 12 17C10.8954 17 10 16.1046 10 15C10 13.8954 10.8954 13 12 13ZM18.2769 4H14.5804L13.1518 6.50003L14.2129 8.35698C14.6518 8.50312 15.0714 8.69156 15.4669 8.91744L18.2769 4ZM9.41968 4H5.72318L8.53314 8.91743C9.47618 8.37877 10.5566 8.0531 11.7088 8.00595L9.41968 4Z"
	})
});
export default SvgMedalLine;
